var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNegative(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_655_10374)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 0C12.5625 0 0 12.5626 0 28.0035C0 35.4632 2.91667 42.4919 8.21528 47.7894C13.5139 53.087 20.5417 56.0069 28 56.0069C35.4653 56.0069 42.4931 53.087 47.7847 47.7894C53.0833 42.4919 56 35.4632 55.9931 28.0035C55.9931 12.5626 43.4306 0.0069522 27.9931 0.0069522L28 0ZM28.0347 52.6351H27.9444C21.3611 52.6143 15.1736 50.0211 10.5347 45.3492C5.89583 40.6704 3.35417 34.469 3.375 27.8853C3.42361 14.3702 14.4653 3.37877 27.9792 3.37877H28.0694C34.6597 3.39963 40.8403 5.9928 45.4861 10.6647C50.1319 15.3435 52.6667 21.5449 52.6389 28.1286C52.5764 41.6437 41.5417 52.6351 28.0347 52.6351Z",
    fill: "url(#paint0_linear_655_10374)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7708 16.4836C38.0694 15.8301 36.9722 15.8649 36.3194 16.5671L28 25.4589L19.6805 16.5671C19.0278 15.8649 17.9236 15.8301 17.2292 16.4836C16.5278 17.1371 16.493 18.2425 17.1458 18.9378L25.618 27.9965L17.1458 37.0552C16.493 37.7574 16.5278 38.8558 17.2292 39.5093C17.5625 39.8222 17.993 39.9751 18.4167 39.9751C18.8819 39.9751 19.3403 39.7874 19.6875 39.4259L28.0069 30.534L36.3264 39.4259C36.6667 39.7944 37.1319 39.9751 37.5972 39.9751C38.0208 39.9751 38.4514 39.8222 38.7847 39.5093C39.4861 38.8558 39.5208 37.7504 38.868 37.0552L30.3958 27.9965L38.868 18.9378C39.5208 18.2356 39.4861 17.1371 38.7847 16.4836H38.7708Z",
    fill: "url(#paint1_linear_655_10374)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_655_10374",
    x1: 0,
    y1: 28.0035,
    x2: 55.9931,
    y2: 28.0035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#930006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C80008"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_655_10374",
    x1: 16.6787,
    y1: 27.9956,
    x2: 39.3352,
    y2: 27.9956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#930006"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C80008"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_655_10374"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNegative);
export default __webpack_public_path__ + "static/media/negative.0b4cccec1894ea6676f7afb0d54db86e.svg";
export { ForwardRef as ReactComponent };